import { render, staticRenderFns } from "./usermgt.vue?vue&type=template&id=67f7c813&scoped=true"
import script from "./usermgt.vue?vue&type=script&lang=js"
export * from "./usermgt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f7c813",
  null
  
)

export default component.exports